import { getParamsQueryString } from '../helpers';
const ACT_LOADMORE_SEARCH = 'ACT_LOADMORE_SEARCH';
let params = getParamsQueryString();
let btnLoadmore = document.querySelector('.loadMorePageSearch');
let wrapList = document.querySelector('.loadMore_list');
export const LoadmoreSearchData = {
    type: ACT_LOADMORE_SEARCH,
    wrapList: wrapList ? wrapList : null,
    btnLoadmore: btnLoadmore ? btnLoadmore : null,
    paged: 2,
    payload: {
        action: 'load_more_search',
        params: params
    }
};
